export default "__VITE_ASSET__UlzBUG4U__"